import { Alert, AlertTitle } from '@mui/material';
import { useHeadlessCheckoutContext } from '@/context/HeadlessCheckoutContext';

const GiftOrderWarningBanner = () => {
  const { data } = useHeadlessCheckoutContext();
  const isGiftOrder = data?.cart?.properties?.is_gift_order === 'true';

  if (!isGiftOrder) {
    return null;
  }

  return (
    <div className="checkout__panel">
      <Alert 
        severity="warning" 
        sx={{ 
          fontFamily: '"Montserrat", sans-serif',
          borderRadius: '12px',
          '& .MuiAlert-message': {
            fontFamily: 'inherit',
            width: '100%',
          },
          '& .MuiAlertTitle-root': {
            fontFamily: 'inherit',
            fontWeight: 600,
            marginBottom: '8px',
          }
        }}
      >
        <AlertTitle>Important: Verify Shipping Address</AlertTitle>
        When using accelerated payment methods such as <strong>Shop Pay, Apple Pay, or Google Pay</strong>, 
        your saved payment address may override the recipient&apos;s address you entered. 
        Please review and confirm the shipping address before completing your order to ensure 
        your gift is delivered to the correct recipient.
      </Alert>
    </div>
  );
};

export default GiftOrderWarningBanner;

